import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Field } from '../../../_reusable/Form/Field';
import { InputField, FIELD_STYLE_OUTLINED } from '../../../_reusable/Input/Input';

const Email = ({
  value, updateValue, name,
}) => {
  return (
    <InputField
      fieldStyle={FIELD_STYLE_OUTLINED}
      label="Vaš email *"
      value={value || ''}
      onChange={val => updateValue(name, val)}
    />
  );
};

Email.propTypes = {
  value: PropTypes.string,
  updateValue: PropTypes.func,
  name: PropTypes.string,
};

Email.defaultProps = {
  value: null,
  updateValue: f => f,
  name: '',
};

const emailValidator = (user) => {
  const format = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
  return format.test(user);
};

export const EmailField = () => (
  <Field
    name="email"
    component={props => <Email {...props} />}
    validationFunc={emailValidator}
    required
  />
);
